<template>
  <c-row>
    <div class="pageHeaderDocumentation p-3">
      <c-container class="h-100 d-flex align-items-center">
        <slot name="header"></slot>
      </c-container>
    </div>
    <c-container>
      <slot></slot>
    </c-container>
  </c-row>
</template>

<script>
export default {
  name: 'teste',
  mounted() {},
}
</script>
<style lang="scss">
.pageHeaderDocumentation {
  background-color: $light-primary;
  width: 100vw;
  height: 30vh;
}

.pageHeaderDocumentation h1 {
  color: $primary;
  font-size: 30px;

  margin-top: 20px;
}

.pageHeaderDocumentation p {
  color: $primary;
  font-size: 20px;
  display: block;
}
</style>
